import React from "react";
import { Control, FieldValues } from "react-hook-form";
import SelectField, { SelectFieldOption } from "components/UI/SelectField";
import { useRecoilValue } from "recoil";
import { workCollectionsState } from "store/atoms/work_collections";
import { workCollectionOptionsGet } from "util/work_collection_common";

type Props = {
  name: string;
  control: Control<FieldValues, any>;
  label: string;
  defaultValue?: string | number | null;
  onSelect?: Function;
  includeEmpty?: boolean;
};

const WorkCollectionSelect = ({
  name,
  control,
  label,
  defaultValue,
  onSelect,
  includeEmpty,
}: Props) => {
  const workCollections = useRecoilValue(workCollectionsState);

  const workCollectionOptions: SelectFieldOption[] = workCollectionOptionsGet(
    workCollections,
    includeEmpty,
    "All"
  );

  return (
    <SelectField
      name="workCollection"
      control={control}
      label="Work Collection"
      options={workCollectionOptions}
      defaultValue={defaultValue}
      onSelect={onSelect}
    />
  );
};

export default WorkCollectionSelect;
